import { Container, Row, Col, Image } from 'react-bootstrap';

const AboutPage = () => {
  return (
    <section className="bg-white py-5">
      <Container>
        <Row className="mb-4">
          <Col>
            <h1 className="display-5 fw-bold">About Aspen Functional Health</h1>
            <p className="lead text-muted">
              Aspen Functional Health was founded in 2022 with the mission of
              providing compassionate, evidence-based nutrition care to
              individuals and families striving for sustainable lifestyle
              change. We proudly collaborate with organizations like Blue Cross
              Blue Shield of Arizona, Prosano, and Kinwell—partners who share
              our belief in the power of preventive care. By working alongside
              these organizations, we aim to keep our communities healthy
              through proactive nutrition support. In a world full of
              conflicting information, we’re here to cut through the noise and
              offer clear, personalized guidance you can trust.
            </p>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="h4 fw-bold">Meet Our Founder</h2>
            <p>
              Natalie Arroyo, MS, RDN, is a highly experienced Registered
              Dietitian Nutritionist with a background in clinical and private
              practice settings. She holds a Bachelor's degree in Nutrition &
              Exercise Science and a Master's degree in Nutrition & Dietetics
              from Bastyr University. Her advanced training includes over 2,000
              hours of supervised practice through Yale New Haven Hospital,
              affiliated with the Yale School of Medicine.
            </p>
            <p>
              Natalie founded Aspen Functional Health with a deep desire to make
              medical nutrition counseling more accessible and impactful for the
              community. She recognized that many people face barriers to
              receiving the care they need, whether due to cost, location, or
              lack of options. To address this, Natalie built Aspen Functional
              Health around the idea of accepting insurance as the primary form
              of payment, ensuring affordability for a wider range of
              individuals. She also prioritized offering telehealth services,
              making it easier for people to access professional support from
              the comfort of their homes.
            </p>
            <p>
              What started as a local initiative has now grown into a thriving
              organization operating across multiple states, improving the
              health and well-being of communities nationwide. Through her
              vision and dedication, Natalie and her team are empowering
              individuals to take control of their health and providing the
              tools needed for long-term, sustainable wellness.
            </p>
          </Col>
          <Col md={6} className="text-center rounded">
            <Image
              src="/images/natalie-arroyo-large.webp"
              alt="Natalie Arroyo"
              fluid
              className="rounded-5 shadow-lg"
              style={{ maxWidth: '400px' }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutPage;
